import React from "react";
import { Box, Heading } from "@chakra-ui/react";
import { TimeLine } from "../../Components";

const testData = [
  {
    institution:
      "Ministry of Transport, Infrastructure and Housing Development",
    year: "Jan 2015 – Dec 2017",
    certification: "Attachee (Industrial Attachment)",
    description:
      "Completed  and obtained my Diploma Certificate in Information Technology.",
    logoUrl: "asset/company.png",
  },
  {
    institution:
      "Ministry of Transport, Infrastructure and Housing Development",
    year: "Jan 2015 – Dec 2017",
    certification: "Attachee (Industrial Attachment)",
    description:
      "Completed  and obtained my Diploma Certificate in Information Technology.",
    logoUrl: "asset/company.png",
  },
  // Add more items as needed
];

const Experience = () => {
  return (
    <Box p={4} id="experience" mt="100px">
      <Box>
        <Heading mb={8} textAlign={{ base: "center", md: "left" }}>
          Experience
        </Heading>
        <Box>
          <TimeLine items={testData} />
        </Box>
      </Box>
    </Box>
  );
};

export default Experience;
